import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';

const ModalConfirm = (props) => {
    return (
        <Dialog header="" visible={props.display} style={{ width: '50vw' }} footer="" onHide={() => props.closeFunc(false)}>
            <p>
                <label>{props.title}</label>
            </p>
            <button className="btn btn-primary" onClick={() => props.closeFunc(true)}>OK</button>
        </Dialog>

    );
}


export default ModalConfirm;

